import { BifrostDateTimePicker, BifrostLoader } from "@/Components/elements"
import { Button, Container, Form, Header, Label, List, Message } from "semantic-ui-react"
import BifrostModal from "../../../BifrostPageComponent/BifrostModal/BifrostModal"
import BifrostConfirmModalActions from "../../../BifrostPageComponent/BifrostModal/BifrostModalActions/BifrostConfirmModalActions"
import { useAddSubnetMappingModal } from "./hooks/useAddSubnetMappingModal"

const AddSubnetMappingModal = ({ directTunnelData, getDirectTunnelSubnetMapping }) => {
	const {
		state,
		directTunnelUserMappings,
		addDirectTunnelSubnetMappingStates,
		handleModalOpen,
		handleChooseUser,
		handleAddressInput,
		handlePrefixInput,
		handleInputReason,
		handleSwitchMode,
		handleConfirm,
		handleCancel,
		handleSetTimeBase,
		handleResetTimeRangeValidation
	} = useAddSubnetMappingModal(directTunnelData, getDirectTunnelSubnetMapping)

	return (
		<BifrostModal
			title={"Direct IP Tunnel Mapping"}
			open={state.addSubnetMappingModal}
			setOpen={handleModalOpen}
			modalPage={
				<BifrostLoader backgroundColor="white" inverted height="1px" minHeight="20px" isLoading={addDirectTunnelSubnetMappingStates.isFetching}>
					<Form>
						{addDirectTunnelSubnetMappingStates.error ? (
							<Message negative>{addDirectTunnelSubnetMappingStates.error}</Message>
						) : (
							<>
								{/* Peers */}
								<Header as="h5">Peers</Header>
								<Form.Select
									fluid
									search
									name="user_id"
									placeholder={state.isNotChooseUser ? "Please select user" : "Select User"}
									loading={directTunnelUserMappings.isLoading}
									options={state.userOptions || []}
									error={state.isNotChooseUser || directTunnelUserMappings.error}
									onChange={(e, data) => handleChooseUser(data)}
								/>
								{state.peers !== null &&
									(state.peers.length === 0 ? (
										<Label color="grey" basic style={{ marginBottom: "15px" }}>
											<div style={{ backgroundColor: "red" }}>test</div> Selected user has no peers
										</Label>
									) : (
										<List selection relaxed bulleted>
											{state.peers.map((peer, index) => (
												<List.Item key={index}>
													<List.Description>{peer}</List.Description>
												</List.Item>
											))}
										</List>
									))}
								{/* Subnet Profile */}
								<Header as="h5">Subnet Profile</Header>
								<Form.Group widths={16}>
									<Form.Input
										width={12}
										name="subnet"
										onChange={(e, data) => handleAddressInput(data.value)}
										placeholder={state.isNotInputAddress ? "Please input subnet address" : "e.g. 0.0.0.0"}
										error={state.isNotInputAddress || state.isNotValidatedAddress}
									/>
									<Form.Input
										width={4}
										name="prefix"
										onChange={(e, data) => handlePrefixInput(data.value)}
										placeholder={state.isNotInputPrefix ? "Please input subnet prefix" : "1-32"}
										error={state.isNotInputPrefix || state.isNotValidatedPrefix}
									/>
								</Form.Group>
								{/* Life Span */}
								<Header as="h5">Lifespan</Header>
								<Container textAlign="center">
									<Button.Group>
										{/* the button basic style has the button color as gray, for stage the extra button in future. */}
										{/* If direct to use not equal, that can not choose for the third button in future. */}
										<Button basic={!(state.mode === "scheduled")} onClick={() => handleSwitchMode("scheduled")}>
											Scheduled
										</Button>
										<Button basic={!(state.mode === "permanent")} onClick={() => handleSwitchMode("permanent")}>
											Permanent
										</Button>
									</Button.Group>
								</Container>
								<Container style={{ marginTop: "20px", height: "220px" }}>
									<Message size="mini" style={{ display: "flex", alignItems: "center", color: "black" }}>
										{state.mode === "permanent" && <>Permanent Subnet Mappings will activate upon confirmation.</>}
										{state.mode === "scheduled" && <>Please choose the activation and deactivation time</>}
									</Message>
									{state.mode === "scheduled" && (
										<>
											<BifrostDateTimePicker.DateTimeRangePicker
												dateTimePickerHandler={handleSetTimeBase}
												validateInput={state.isNotInputTimeBase}
												validateTimeRange={state.isNotValidatedTimeRange}
												resetTimeRangeValidation={handleResetTimeRangeValidation}
											/>
											{/* Reason */}
											<Container style={{ marginTop: "20px" }}>
												<Form.TextArea placeholder="Reason..." onChange={(e) => handleInputReason(e)} />
												<div style={{ display: "flex", alignItems: "center", color: "black" }}>*Please don't share sensitive infomation in the Reason field.</div>
											</Container>
										</>
									)}
								</Container>
							</>
						)}
					</Form>
				</BifrostLoader>
			}
			trigger={
				<div
					onClick={() => handleModalOpen(true)}
					style={{
						cursor: "pointer",
						color: "#2196F3",
						display: "flex",
						justifyContent: "end",
						alignItems: "center"
					}}
				>
					+ Add Configuration
				</div>
			}
			modalActions={
				<BifrostConfirmModalActions
					isError={addDirectTunnelSubnetMappingStates.error}
					errorHandler={() => handleCancel()}
					loading={addDirectTunnelSubnetMappingStates.isFetching}
					confirmButtonColor="green"
					confirmText="Confirm"
					confirmHandler={() => handleConfirm()}
					cancelHandler={() => handleCancel()}
				/>
			}
		/>
	)
}

export default AddSubnetMappingModal
